import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { getBoardList } from '@api/api';

const HOME_ARCHIVE_TABS = [
  {
    name: '서식자료',
    path: '/archive/document',
    boardCode: 'B01',
    posts: [],
  },
  {
    name: '매뉴얼',
    path: '/archive/manual',
    boardCode: 'C01',
    posts: [],
  },
  {
    name: '변액자료',
    path: '/archive/variable',
    boardCode: 'D01',
    posts: [],
  },
];

const HomeMainArchive = () => {
  const [tabPostInfos, setTabPostInfos] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [currentTab, setCurrentTab] = useState(HOME_ARCHIVE_TABS[tabIndex]);

  useEffect(() => {
    let isMounted = true;

    const initTapPosts = async () => {
      const tabPostPromises = HOME_ARCHIVE_TABS.map(({ boardCode }) => {
        const params = {
          bbsClssCd: boardCode,
          targetRow: 1,
          rowSize: 5,
        };

        return $utils.fetchPosts(params, getBoardList);
      });

      const tabPostResults = await Promise.all(tabPostPromises);
      const tabPosts = tabPostResults.map(({ postInfos }) => postInfos);

      if (isMounted) setTabPostInfos(tabPosts);
    };

    // 로컬 테스트시 느려서 막음
    if (!$utils.isLocal) {
      initTapPosts();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(
    () =>
      setCurrentTab({
        ...HOME_ARCHIVE_TABS[tabIndex],
        posts: tabPostInfos[tabIndex],
      }),
    [tabIndex, tabPostInfos],
  );

  return (
    <div className="app-box-main">
      <div className="ico-group-2 ico-new-library">
        <h3 className="tit3">자료실</h3>
      </div>

      <ul className="tab-type6">
        {HOME_ARCHIVE_TABS.map(({ name }, index) => (
          <li
            key={index}
            className={$classNames({ active: index === tabIndex })}
            onClick={() => setTabIndex(index)}
          >
            <span className="tab">{name}</span>
          </li>
        ))}
      </ul>

      <div className="tab-cont active" id={`ga-tab${tabIndex + 1}`}>
        <ul className="notice-board-list">
          {currentTab.posts?.length > 0 ? (
            currentTab.posts.map(
              (
                { bbsSno, bbsTitle, newBbsYn, atchFileYn, fstRegDdtm },
                index,
              ) => (
                <li
                  key={index}
                  className={$classNames('new', {
                    'border-none': index === currentTab.posts?.length - 1,
                  })}
                >
                  <Link to={`${currentTab.path}/detail?postId=${bbsSno}`}>
                    <span className="txt">{bbsTitle}</span>

                    {newBbsYn === 'Y' && <em className="ico ico-new">new</em>}
                    {atchFileYn === 'Y' && (
                      <em className="ico ico-add-file">file</em>
                    )}

                    <span className="date">
                      {format(new Date(fstRegDdtm), 'yyyy.MM.dd')}
                    </span>
                  </Link>
                </li>
              ),
            )
          ) : (
            <li>
              <div className="round-box bd-type no-data">
                게시물이 없습니다.
              </div>
            </li>
          )}
        </ul>
      </div>

      <Link className="ico-arrow" to={currentTab.path}>
        더보기
      </Link>
    </div>
  );
};

export default HomeMainArchive;
